import React from "react";
import { Box, Typography, List, ListItem, ListItemText } from "@mui/material";

const PrivacyPolicy = () => {
  return (
<Box
      sx={{
        p: 4,
        backgroundColor: "#f5f5f5",
        display: "flex",    
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
        <Box
          sx={{
            position: "relative",
            // height: "300px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            // marginBlock:'0.8rem',
            padding: 2,
            marginBlock:'2rem',
            backgroundColor: "white",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            borderRadius: "16px",
            maxWidth:800
          }}
        >
      <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
        Privacy Policy
      </Typography>
      <Typography variant="body1" gutterBottom>
        Aastha computers is committed to safeguarding the privacy of our students
        and visitors. This Privacy Policy explains how we collect, use, and
        protect your personal information.
      </Typography>

      <Typography variant="h5" gutterBottom sx={{ mt: 4, fontWeight: "bold" }}>
        Information We Collect
      </Typography>
      <List>
        <ListItem>
          <ListItemText
            primary="1. Personal Identification Information"
            secondary="Name, contact details, address, and education qualifications."
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="2. Enrollment Details"
            secondary="Course preferences, attendance, and payment information."
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="3. Usage Data"
            secondary="Details about your use of our website and services for improvement and analysis purposes."
          />
        </ListItem>
      </List>

      <Typography variant="h5" gutterBottom sx={{ mt: 4, fontWeight: "bold" }}>
        How We Use Data
      </Typography>
      <Typography variant="body1">
        We respect your privacy and are committed to using your data solely for:
      </Typography>
      <List>
        <ListItem>
          <ListItemText
            primary="1. Improving Quality"
            secondary="Analyzing performance and feedback to enhance course materials and learning experiences."
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="2. Marketing and Updates"
            secondary="Informing students of new courses, special offers, and events, with consent."
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="3. Research"
            secondary="Using anonymized data for academic and market research aimed at improving education standards."
          />
        </ListItem>
      </List>

      <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
        We will never sell or share your personal information with external
        parties without your consent. This policy ensures that your information
        is safe, secure, and only used as per your agreement.
      </Typography>
      </Box>
    </Box>
  );
};

export default PrivacyPolicy;
